import { useTRPC } from '@/utils/trpc';
import { QueryStateHandler } from '@liza/ui/components/QueryStateHandler';
import { VitalDetail } from '@liza/ui/components/records/VitalDetail';
import { formatCodeableConcept } from '@medplum/core';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type Props = {
  vitalIdentifier: string;
  medplumPatientId: string;
};

export const VitalDetailContent = ({ vitalIdentifier, medplumPatientId }: Props): React.ReactNode => {
  const { t } = useTranslation('common');
  const trpc = useTRPC();

  const observationsQuery = useQuery(
    trpc.patient.observation.list.queryOptions({
      category: 'vitals',
      medplumPatientId,
      options: { status: 'active', searchParams: { code: vitalIdentifier, _count: 100, _offset: 0 } },
    }),
  );

  const vitalsForIdentifier = observationsQuery.data?.observations ?? [];

  return (
    <QueryStateHandler query={observationsQuery} emptyMessage={t('noRecordsAvailable')}>
      {() => {
        if (vitalsForIdentifier.length === 0) return <p className="p-4">{t('vitalNotFound')}</p>;
        const vitalName = formatCodeableConcept(vitalsForIdentifier.at(0)?.code);
        return <VitalDetail vitalName={vitalName} results={vitalsForIdentifier} />;
      }}
    </QueryStateHandler>
  );
};
